module.exports = __webpack_public_path__ + "img/homePagePopCouponsBg.39e629cd.png";